import React from "react";
import toast from "react-hot-toast";
import { createCustomerContact } from "../../../utils/api/customers";
import { Button, Form, Modal } from "react-bootstrap";

type ContactModalProps = {
    open: boolean;
    customerId: number;
    onClose: () => void;
    onSaved: () => void;
};

export const ContactModal: React.FC<ContactModalProps> = ({
    open,
    customerId,
    onClose,
    onSaved
}) => {
    const [name, setName] = React.useState('');
    const [phoneNumber, setPhoneNumber] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [phoneError, setPhoneError] = React.useState('');

    React.useEffect(() => {
        if (!open) {
            setName('');
            setPhoneNumber('');
        }
    }, [open]);

    const validatePhone = (phone: string): boolean => {
        return /^9\d{8}$/.test(phone)
    }

    if (!open) return null;

    const saveContact = async () => {
        if (!name || !phoneNumber) {
            toast.error('Completa nombre y teléfono');
            return;
        }

        if (!validatePhone(phoneNumber)) {
            setPhoneError('El teléfono debe empezar con 9 y tener 9 dígitos')
            return;
        }

        try {
            setLoading(true);

            await createCustomerContact({
                customerId,
                name,
                phoneNumber
            });

            toast.success('Contacto registrado');
            onSaved(); // reintenta crear la orden
        } catch (e: any) {
            toast.error(e.response?.data?.message || 'Error al guardar contacto');
        } finally {
            setLoading(false);
            setName('');
            setPhoneNumber('');
        }
    };

    return (
        <Modal show={open} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Registrar contacto del cliente</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Este cliente no tiene contactos registrados.
                    Para continuar con la venta, ingresa al menos uno.
                </p>
                <Form.Group controlId="contactName" className="mb-3">
                    <Form.Label>Nombre del contacto</Form.Label>
                    <Form.Control placeholder="Nombre del contacto" value={name} onChange={e => setName(e.target.value)} />
                </Form.Group>
                <Form.Group controlId="contactPhone" className="mb-3">
                    <Form.Label>Teléfono</Form.Label>
                    <Form.Control
                        type="tel"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        placeholder="Ej: 987654321"
                        maxLength={9}
                        value={phoneNumber}
                        onChange={e => {
                            const value = e.target.value.replace(/\D/g, '');
                            setPhoneNumber(value);
                            setPhoneError('')
                        }}
                        isInvalid={!!phoneError}
                    />
                    {phoneError && (
                        <Form.Control.Feedback type="invalid">
                            {phoneError}
                        </Form.Control.Feedback>
                    )}
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose} disabled={loading}>
                    Cancelar
                </Button>

                <Button onClick={saveContact} disabled={loading}>
                    {loading ? 'Guardando...' : 'Guardar y continuar'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};